import { Col, Row, Tab, Tabs, Button } from 'react-bootstrap';
import { Link} from "react-router-dom";
import { useState, useEffect } from 'react';

import BasicSpinner from '../components/common/basic-spinner';
import PaginateList from '../components/common/pagination';

import { useAuth } from "../utils/auth-provider";
import { fetchUserCollections, fetchUserItems, fetchUserImages } from '../utils/fetch-helpers';

//================================================================

export default function Dashboard() {

  const user = useAuth();

  const [collections, setCollections] = useState();
  const [items, setItems] = useState();
  const [images, setImages] = useState();
  const [key, setKey] = useState('collections');

  //----------------------------------------------------------------

  const fetchAll = async (signal) => {
    setCollections(await fetchUserCollections(user, signal));
    setItems(await fetchUserItems(user, signal));
    setImages(await fetchUserImages(user, signal));
  };

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchAll(signal);

    return () => {
      // Cancel the request when the component unmounts
      abortController.abort();
    };

  }, []);

  //----------------------------------------------------------------

  return (
    <>
      <Row className="mb-2">
        <Col className="h4">
          Your Entries
        </Col>
      </Row>

      <Tabs
        defaultActiveKey="profile"
        id="uncontrolled-tab-example"
        className="mb-3"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        {/*Tab content for Collections*/}
        <Tab eventKey="collections" title="Collections">
          <Row className="mb-2 align-children-center justify-content-center">
            <Col className="h5 my-0 col-md-6">
              <Link
                to="/dashboard/collections/"
                className="link-dark link-underline-opacity-0 link-underline-opacity-100-hover"
              >
                <Button className="text-nowrap btn w-100">
                  Go To Collections
                </Button>
              </Link>
            </Col>
          </Row>
          {!collections ?
            <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
            :
            <PaginateList
              key='user-collections'
              list={collections}
              type='collection'
              isPrivate={true}
            />
          }
        </Tab>

        {/*Tab for Items*/}
        <Tab eventKey="items" title="Items">
          <Row className="mb-2 align-children-center justify-content-center">
            <Col className="h5 my-0 col-md-6">
              <Link
                to="/dashboard/items/"
                className="link-dark link-underline-opacity-0 link-underline-opacity-100-hover"
              >
                <Button className="text-nowrap btn w-100">
                  Go To Items
                </Button>
              </Link>
            </Col>
          </Row>

          {!items ?
            <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
            :
            <PaginateList
              key='user-items'
              list={items}
              type='item'
              isPrivate={true}
            />
          }
        </Tab>

        {/*Tab for Images*/}
        <Tab eventKey="images" title="Images">
          <Row className="mb-2 align-children-center justify-content-center">
            <Col className="h5 my-0 col-md-6">
              <Link
                to="/dashboard/images/"
                className="link-dark link-underline-opacity-0 link-underline-opacity-100-hover"
              >
                <Button className="text-nowrap btn w-100">
                  Go To Images
                </Button>
              </Link>
            </Col>
          </Row>

          {!images ?
            <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
            :
            <PaginateList
              key='user-images'
              list={images}
              type='image'
              isPrivate={true}
            />
          }
        </Tab>
      </Tabs>
    </>
  );
}
